
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth, signInAnonymously } from 'firebase/auth';

import { FirebaseConfig } from './FirebaseConfig'; 


class FirebaseClient {
    constructor() {
      const app = initializeApp(FirebaseConfig);
      const auth = getAuth(app);
      this.auth = auth;
      this.functions = getFunctions(app, "us-central1");
      /*
      signInAnonymously(auth)
        .then(() => {
            console.log("Signed in anonymously");
            // now safe to call httpsCallable
        })
        .catch((error) => {
            console.error("Anonymous sign-in failed", error);
        });
        */
    }

    async sendRequest(app, email, requestType, additionalInfo, recaptchaToken) {
        try {
            await signInAnonymously(this.auth);
            console.log("Signed in anonymously");
            const token = await this.auth.currentUser.getIdToken();

            const response = await fetch("https://us-central1-jess-apps-4420.cloudfunctions.net/sendDataRequest", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ app, email, requestType, additionalInfo, recaptchaToken })
            });

            const data = await response.json(); 

            return {
                status: data.status ?? response.status,
                message: data.message ?? "No message returned"
            };
        } catch (error) {
            console.error("Error sending message: ", error);
    
            return {
                status: error.code === 'auth' ? 506 : 505,
                message: `Error: ${error.message}`
            };
        }
    }
}


const firebaseClient = new FirebaseClient();
export default firebaseClient;

